
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[[...blogSlug]]",
      function () {
        return require("private-next-pages/blog/[[...blogSlug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[[...blogSlug]]"])
      });
    }
  